import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { ReadyForContactFormComponent } from '../../components/ready-for-contact-form/ready-for-contact-form.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reagents-page',
  standalone: true,
  templateUrl: './reagents-page.component.html',
  styleUrl: './reagents-page.component.scss',
  imports: [
    CommonModule,
    ModuleContainerDirective,
    ReadyForContactFormComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReagentsPageComponent {
  private readonly route = inject(ActivatedRoute);
  public readonly data$ = this.route.data.pipe(map(d => d['data']));
}
